export function noUndefinedProps(obj) {
  const o = {};
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] !== 'undefined') o[key] = obj[key];
  });
  return o;
}
export function isStringProp(val) {
  return typeof val === 'string' && val !== '';
}
export function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
}
export function now() {
  return Date.now();
}
export function extend(...args) {
  let deep = true;
  let to;
  let from;
  if (typeof args[0] === 'boolean') {
    [deep, to] = args;
    args.splice(0, 2);
    from = args;
  } else {
    [to] = args;
    args.splice(0, 1);
    from = args;
  }
  for (let i = 0; i < from.length; i += 1) {
    const nextSource = args[i];
    if (nextSource !== undefined && nextSource !== null) {
      const keysArray = Object.keys(Object(nextSource));
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (!deep) {
            to[nextKey] = nextSource[nextKey];
          } else if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            extend(to[nextKey], nextSource[nextKey]);
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};
            extend(to[nextKey], nextSource[nextKey]);
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}

export function classNames(...args) {
  const classes = [];
  args.forEach((arg) => {
    if (typeof arg === 'object' && arg.constructor === Object) {
      Object.keys(arg).forEach((key) => {
        if (arg[key]) classes.push(key);
      });
    } else if (arg) classes.push(arg);
  });
  const uniqueClasses = [];
  classes.forEach((c) => {
    if (uniqueClasses.indexOf(c) < 0) uniqueClasses.push(c);
  });
  return uniqueClasses.join(' ');
}

export function createEmitter(createEventDispatcher, props) {
  const dispatch = createEventDispatcher();
  const emit = (events, argsArray) => {
    if (!events || !events.trim().length || typeof events !== 'string') return;

    events
      .trim()
      .split(' ')
      .forEach((event) => {
        const eventName = (event || '').trim();
        if (!eventName) return;
        const propName = `on${eventName.charAt(0).toUpperCase() + eventName.slice(1)}`;
        dispatch(eventName, argsArray);

        if (typeof props[propName] === 'function') props[propName](...argsArray);
      });
  };
  return emit;
}

let routerIdCounter = 0;
let routerComponentIdCounter = 0;

export function unsetRouterIds() {
  routerIdCounter = 0;
  routerComponentIdCounter = 0;
}

export function getRouterId() {
  routerIdCounter += 1;
  return `${now()}_${routerIdCounter}`;
}

export function getComponentId() {
  routerComponentIdCounter += 1;
  return `${now()}_${routerComponentIdCounter}`;
}

export function plainText(text) {
  if (typeof text === 'undefined' || text === null) return '';
  return text;
}

export function dagInterpolateNumberWithCommas(cell, formatterParams, onRendered) {
  return Number(cell.getValue()).toLocaleString("en-US")
}

export function dagFixedDecimal(cell, formatterParams, onRendered) {
  return Number(cell.getValue()).toFixed(1) 
}

export function dagTrainingStatusIconDownloadAccessor(value, data, type, params, column) {
  switch(value) {
    case '2':
      return 'Complete'
      break;
    case '3':
      return 'Exceeded'
      break;
    case '1':
      return 'Not Complete'
      break;
    case '4':
      return 'Exempt'
      break;
    default:
      return '<empty>'
  }
  return value
}

export function dagTrainingStatusIconFormatter(cell, formatterParams, onRendered) {
  switch(cell.getValue()) {
    case '2':
      return '<i class="fa-solid fa-bullseye-arrow" style=" color: #cdff07; background-color: #1d341f; border-radius: 50%; padding: 0.1em;" aria-label="Complete" role="img" aria-hidden></i><span class="sr-only">Complete</span>'
      break;
    case '3':
      return '<i class="fa-solid fa-party-horn" style="color:#008328" aria-label="Exceeded" role="img" aria-hidden></i><span class="sr-only">Exceeded</span>'
      break;
    case '1':
      return '<i class="fa-solid fa-siren-on" style="color:#ff720d" aria-label="Not Complete" role="img" aria-hidden></i><span class="sr-only">Not Complete</span>'
      break;
    case '4':
      return '<i class="fa-solid fa-do-not-enter" style="color:#e00122" aria-label="Exempt" role="img" aria-hidden></i><span class="sr-only">Exempt</span>'
      break;
    default:
      console.error('Not seeing icons? Invalid value for Training Status. Has the upstream data changed?', cell.getValue())
      return ''
  }
}

export function dag3PStatusIconFormatter(cell, formatterParams, onRendered) {
  const value = cell.getValue()

  switch(value) {
    case 'Exception':
      return '<i class="fa-duotone fa-solid fa-triangle-exclamation" style="color: #ff720d; border-radius: 50%; padding: 0.1em;" aria-label="Exception" role="img" aria-hidden></i><span class="sr-only">Exception</span>'
    case 'Pending':
      return '<i class="fa-duotone fa-solid fa-eye" style="color:#0800ff" aria-label="Pending" role="img" aria-hidden></i><span class="sr-only">Pending</span>'
    case 'Recommended pending accessibility follow-up':
    case 'Approved':
      return '<i class="fa-duotone fa-solid fa-thumbs-up" style="color:#008328" aria-label="Approved" role="img" aria-hidden></i><span class="sr-only">Approved</span>'
    case 'Denied':
      return '<i class="fa-duotone fa-solid fa-thumbs-down" style="color:#e00122" aria-label="Denied" role="img" aria-hidden></i><span class="sr-only">Denied</span>'
    default:
      console.error(`Invalid status value for 3rd Party item: ${cell.getValue()}... Has the upstream data changed?`)
      return value
  }
}

export function dagAcademicStatusIconFormatter(cell, formatterParams, onRendered) {
  switch(String(cell.getValue())) {
    case '4':
      return '<i class="fa-solid fa-party-horn" style="color:#008328" aria-label="Keep up the good work!" role="img" aria-hidden></i><span class="sr-only">Keep up the good work!</span>'
    case '3':
      return '<i class="fa-solid fa-bullseye-arrow" style="color: #cdff07; background-color: #1d341f; border-radius: 50%; padding: 0.1em;" aria-label="Great start!" role="img" aria-hidden></i><span class="sr-only">Great start!</span>'
    case '2':
      return '<i class="fa-solid fa-siren-on" style="color:#ff720d" aria-label="Attention Needed!" role="img" aria-hidden></i><span class="sr-only">Attention Needed!</span>'
    case '1':
      return '<i class="fas fa-exclamation-circle " style="color:#e00122" aria-label="Attention Required!" role="img" aria-hidden></i><span class="sr-only">Attention Required! </span>'
    default:
      console.error('Not seeing icons? Invalid value for Academic Status. Has the upstream data changed?', cell.getValue())
      return ''
  }
}

export function dagEmailLinkFormatter(cell, formatterParams, onRendered) {
  const value = cell.getValue()
  if (!value || value.trim() === '') return ''
  return '<a href="mailto:' + value + '">' + value + '</a>'
}